import { Injectable } from '@angular/core';
import { Observable, of, shareReplay, tap } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as overviewActions from '../actions/overview';
import { OverviewHttpService } from '../services/overview-http.service';
import { GetOverviewResponse } from '../models/overview';
import { IOverviewConfigurationModel } from '../models/overview-configuration-model';
import {EntityKey} from "@pma-entity/pma-entity-types";
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class OverviewEffects {

  prevEntityKey: EntityKey = undefined;
  prevResponse: GetOverviewResponse = undefined;

  constructor(
    private actions$: Actions,
    private overviewService: OverviewHttpService) {
  }

  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<overviewActions.Load>(overviewActions.LOAD),
    switchMap(action => {
      let completedAction$: Observable<overviewActions.LoadComplete | overviewActions.LoadError>;
      const shouldQueryServer: boolean = !!this.prevResponse
        || !!this.prevEntityKey
        || !_.isEqual(this.prevEntityKey, action.key);
      if (shouldQueryServer) {
        completedAction$ = this.overviewService.getOverview(action.key).pipe(
          switchMap((overview: GetOverviewResponse) => {
            this.prevEntityKey = action.key;
            this.prevResponse = overview;
            return of(new overviewActions.LoadComplete(overview));
          }),
          catchError(err => of(new overviewActions.LoadError(err)))
        );
      } else {
        completedAction$ = of(new overviewActions.LoadComplete(this.prevResponse));
      }
      return completedAction$.pipe(shareReplay());
    })));

  loadAvailableTiles$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<overviewActions.LoadConfiguration>(overviewActions.LOAD_CONFIGURATION),
    switchMap(action => {
      return this.overviewService.getOverviewConfiguration().pipe(
        map((overviewConfiguration: IOverviewConfigurationModel) => new overviewActions.LoadConfigurationComplete(overviewConfiguration)),
        catchError(err => of(new overviewActions.LoadConfigurationError(err)))
      );
    })));

}

